import { useSystem } from '../contextProviders/SystemProvider';

/**
 * Tab properties that drive which tab group is used for thumbnail display.
 */
export type TabProp = {
  name: string;
  label: string;
  studies: any[];
};

/**
 * Collection of tab properties with studies presorted depending on tab mod.
 * This is used in deciding what thumbnails to show.
 */
export type TabsProps = TabProp[];

/**
 *
 * @param {string[]} primaryStudyInstanceUIDs
 * @param {object[]} studyDisplayList
 * @param {string} studyDisplayList.studyInstanceUid
 * @param {string} studyDisplayList.date
 * @param {string} studyDisplayList.description
 * @param {string} studyDisplayList.modalities
 * @param {number} studyDisplayList.numInstances
 * @param {object[]} displaySets
 * @param {number} recentTimeframe - The number of milliseconds to consider a study recent
 * @returns {TabsProps} tabs - The prop object expected by the StudyBrowser component
 */

export function createStudyBrowserTabs(
  primaryStudyInstanceUIDs,
  studyDisplayList,
  displaySets,
  hangingProtocolService,
  cachedService,
  recentTimeframeMS = 31536000000
): TabsProps {
  const { servicesManager } = useSystem();
  const { displaySetService, customizationService } = servicesManager.services;

  const primaryStudies = [];
  const allStudies = [];
  const recentStudies = [];
  studyDisplayList.forEach(study => {
    const displaySetsForStudy = displaySets.filter(
      ds => ds.StudyInstanceUID === study.studyInstanceUid
    );
    //这部分被注释的代码主要是为了保证序列的排序可以根据config配置文件中的配置来排序，但是这样的话
    //就没办法使用panelStudyBrowse中传过来的自定义排序了，所以注释这部分代码
    // const sortCriteria = customizationService.getCustomization('sortingCriteria');
    // const sortedDisplaySets = displaySetsForStudy.sort((a, b) => {
    //   const displaySetA = displaySetService.getDisplaySetByUID(a.displaySetInstanceUID);
    //   const displaySetB = displaySetService.getDisplaySetByUID(b.displaySetInstanceUID);
    //   return sortCriteria(displaySetA, displaySetB);
    // });

    // return displaySetA.SeriesInstanceUID.localeCompare(displaySetB.SeriesInstanceUID);

    const tabStudy = Object.assign({}, study, {
      displaySets: displaySetsForStudy,
    });
    if (primaryStudyInstanceUIDs.includes(study.studyInstanceUid)) {
      primaryStudies.push(tabStudy);
    }
    const existingIndex = cachedService
      .get('studyDisplayList')
      ?.findIndex(rs => rs.studyInstanceUid === study.studyInstanceUid);
    if (existingIndex !== -1) {
      recentStudies.splice(existingIndex, 1);
    }
    recentStudies.push(tabStudy);
    if (recentStudies.length > 5) {
      recentStudies.shift();
    }
    allStudies.push(tabStudy);
  });

  const primaryStudiesTimestamps = primaryStudies
    .filter(study => study.date)
    .map(study => new Date(study.date).getTime());

  // const recentStudies =
  //   primaryStudiesTimestamps.length > 0
  //     ? allStudies.filter(study => {
  //         const oldestPrimaryTimeStamp = Math.min(...primaryStudiesTimestamps);

  //         if (!study.date) {
  //           return false;
  //         }
  //         const studyTimeStamp = new Date(study.date).getTime();
  //         return oldestPrimaryTimeStamp - studyTimeStamp < recentTimeframeMS;
  //       })
  //     : [];

  // Newest first
  const _byDate = (a, b) => {
    const dateA = Date.parse(a);
    const dateB = Date.parse(b);

    return dateB - dateA;
  };

  const tabs = [
    {
      name: 'primary',
      label: '当前检查',
      studies: primaryStudies.sort((studyA, studyB) => _byDate(studyA.date, studyB.date)),
    },
    {
      name: 'recent',
      label: '历史记录',
      studies: recentStudies.sort((studyA, studyB) => _byDate(studyA.date, studyB.date)),
    },
    // {
    //   name: 'all',
    //   label: 'All',
    //   studies: allStudies.sort((studyA, studyB) => _byDate(studyA.date, studyB.date)),
    // },
  ];

  return tabs;
}
